module.exports = __webpack_public_path__ + "e5d536f150961bcd20f0379ef1966934.png";


//////////////////
// WEBPACK FOOTER
// ./shared/images/menu.png
// module id = 993
// module chunks = 2